<template>

    <card class="card">
        <cardHeader>
            <h2 class="text-center">{{title}}</h2>
        </cardHeader>
        <cardBody>
            <progress-bar :percentage="percentage" />
            <h4 v-if="!hide" class="text-center">{{name}} <br /><strong>{{documentNumber}}</strong> of {{totalDocumentCount}}</h4>
            <div class="row p-m">
                <div class="row ">
                    <div class="col-lg-12 col-md-12 col-sm-6 col-xs-12  text-center">
                        <div>
                            Please allow the system time to process your request. Loading times may vary depending on your internet speed and the number of documents. Additionally, if using Safari loading issues more than a minute can occur & refreshing the page may resolve.
                        </div>
                    </div>
                </div>
            </div>
        </cardBody>
    </card>

</template>

<script>
    import moment from "moment";
    import ProgressBar from "@/components/ProgressBar.vue";
    import {
        Card,
        CardHeader,
        CardBody,
        CardTitle
    } from "@progress/kendo-vue-layout";
    export default {
    name: "LoadingCard",
        props: ["percentage", "name", "documentNumber", "totalDocumentCount", "title", "hide", "isRon"],
        emits: [],
        components: {
            ProgressBar,
            card: Card,
            cardHeader: CardHeader,
            cardBody: CardBody,
            cardTitle: CardTitle,
        },
        data() {
            return {
            }
        },
        computed: { moment: () => moment },
        created() {
            console.log("HIDE HIDE HIDE", this.hide);
        },
        async mounted() {
          
        },
        methods: {
        }
    };
</script>
